import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReddit, faVk, faTelegram } from '@fortawesome/free-brands-svg-icons';
import { AnilistLogoSVG, CodebergLogoSVG, YaMusicLogoSVG } from './SVG';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const User = ({ dict, setState }) => (
	<div className="user">
		<div class="exitbtn" onClick={() => setState('home')}>
			<FontAwesomeIcon icon={faArrowLeft} className="exitbtn__icon" />
		</div>
		<div className="user__unit">
			<div className="user__unit__pic"></div>
			<div className='user__unit__info'>
				<div className="user__unit__info__name">Katsuki Amatsuyu</div>
				<ul className="user__unit__info__list">
					{dict.user.infolist.map((el, idx) => {
						return (
							<li className="user__unit__info__list__entry" key={el + idx}>{el}</li>
						)
					})}
				</ul>
			</div>
		</div>
		<div className="user__links">
			<a href="https://reddit.com/u/KatsukiAmatsuyu" className="user__links__entry">
				<FontAwesomeIcon icon={faReddit} className="user__links__entry__icon" id="rdt" />
				<div className="user__links__entry__text">Reddit</div>
			</a>
			<a href="https://vk.com/katsukibtw" className="user__links__entry">
				<FontAwesomeIcon icon={faVk} className="user__links__entry__icon" id="vk" />
				<div className="user__links__entry__text">VKontakte</div>
			</a>
			<a href="https://t.me/katsukibtw" className="user__links__entry">
				<FontAwesomeIcon icon={faTelegram} className="user__links__entry__icon" id="tg" />
				<div className="user__links__entry__text">Telegram</div>
			</a>
			<a href="https://codeberg.org/katsuki" className="user__links__entry">
				<CodebergLogoSVG className="user__links__entry__icon" id="cdb" />
				<div className="user__links__entry__text">Codeberg</div>
			</a>
			<a href="https://music.yandex.ru/users/katsuki.amatsuyu" className="user__links__entry">
				<YaMusicLogoSVG className="user__links__entry__icon" id="yam" />
				<div className="user__links__entry__text">Yandex.Music</div>
			</a>
			<a href="https://anilist.co/user/KatsukiBTW" className="user__links__entry" id="anl">
				<AnilistLogoSVG className="user__links__entry__icon" id="anlsvg" />
				<div className="user__links__entry__text">Anilist</div>
			</a>
		</div>
	</div>
)

export default User;
